var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "stats-name-wrap stats-name-wrap__" + _vm.statusData.dashboardType
    },
    [
      _c(
        "span",
        { staticClass: "stats-number", class: { "today-row": !_vm.isClosed } },
        [_vm._v(_vm._s(_vm.statusCounter))]
      ),
      _vm._v(" "),
      _vm.isClosed && _vm.lastCounter < _vm.statusCounter
        ? _c("span", { staticClass: "arrow-up" })
        : _vm._e(),
      _vm._v(" "),
      _vm.isClosed && _vm.lastCounter > _vm.statusCounter
        ? _c("span", { staticClass: "arrow-down" })
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.isClosed
        ? _c("div", { staticClass: "stats-bar" })
        : _c("div", {
            staticClass: "stats-bar",
            style: { backgroundColor: _vm.statusData.dashboardColor }
          }),
      _vm._v(" "),
      _c("span", { staticClass: "stats-name" }, [
        _vm._v(" " + _vm._s(_vm.statusData.dashboardLabel))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }